export default class Positioning {
    static areOverlapping(oneBox, anotherBox, padding = 0) {
        return oneBox.x + oneBox.width > anotherBox.x - padding
            && oneBox.x < anotherBox.x + anotherBox.width + padding
            && oneBox.y + oneBox.height > anotherBox.y - padding
            && oneBox.y < anotherBox.y + anotherBox.height + padding;
    }
    static arePointsWithinMargin(onePoint, anotherPoint, margin) {
        if (Math.abs(onePoint.x - anotherPoint.x) > margin
            ||
                Math.abs(onePoint.y - anotherPoint.y) > margin)
            return false;
        return true;
    }
}
